import { render, staticRenderFns } from "./ProductItemModal.vue?vue&type=template&id=37b82d7d&scoped=true"
import script from "./ProductItemModal.vue?vue&type=script&lang=js"
export * from "./ProductItemModal.vue?vue&type=script&lang=js"
import style0 from "./ProductItemModal.vue?vue&type=style&index=0&id=37b82d7d&prod&lang=scss&scoped=true"
import style1 from "./ProductItemModal.vue?vue&type=style&index=1&id=37b82d7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b82d7d",
  null
  
)

export default component.exports